import React from "react";
import { TextField, MenuItem, TextFieldProps } from "@mui/material";

export interface SelectFilterOption {
  value: string | number;
  label: string;
}

export type AppSelectFilterProps = Omit<
  TextFieldProps,
  "onChange" | "value"
> & {
  label: string;
  value: string | number;
  onChange: (value: string) => void;
  options: SelectFilterOption[];
  allLabel?: string;
  minWidth?: number | string;
};

const AppSelectFilter: React.FC<AppSelectFilterProps> = ({
  label,
  value,
  onChange,
  options,
  allLabel = "All",
  minWidth = 160,
  sx,
  ...rest
}) => {
  return (
    <TextField
      select
      size="small"
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{ minWidth, ...sx }}
      {...rest}
    >
      {allLabel ? <MenuItem value="">{allLabel}</MenuItem> : null}
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default AppSelectFilter;
